import { FetchError } from '@execonline-inc/fetch.private';
import { UseFetch } from '@execonline-inc/react-hooks.private';
import { nothing } from 'maybeasy';
import { type MissingLinkError } from '../../../../Links';
import * as Resourceable from '../../../../Resourceable';
import { TPlainTextKey } from '../../../../Translations';
import { AssistantRole } from '../../../Chatbot/Types';

type DisplayType = 'carousel' | 'list' | 'grid';

type LearningDesignState = 'custom' | 'curated' | 'blank' | 'build-your-own' | 'browse-all';

export type PublishMode = 'Publish' | 'Create' | 'Save';

export type ConfirmationType = 'show' | 'hide';

export interface ProductCollectionOut {
  name: string | undefined;
  description: string | undefined;
  experiences: number[];
  display_type: DisplayType;
  learning_design_state: LearningDesignState;
}

export interface LearningCollectionOut {
  learning_collection: {
    name: string | undefined;
    description: string | undefined;
    search: string;
    browse_all: boolean;
    learning_designs: ProductCollectionOut[];
    published?: boolean;
    internal_name: string;
    source_identifier?: SourceIdentifier;
    assistant_role?: AssistantRole;
    course_registration_id?: number | undefined;
    product_license_id?: number | undefined;
  };
}

export type SourceIdentifier =
  | 'exo-chat'
  | 'coaching-profiles'
  | 'builder-v2'
  | 'builder-v1'
  | 'clone';

export type NewPreviewState = UseFetch.State<
  FetchError | MissingLinkError,
  Resourceable.ParsedResponse<'/preview_learning_collection_template', 'get'>
>;

export type NewPreviewResource = Resourceable.ResourceFor<
  '/preview_learning_collection_template',
  'get',
  200
>;

export const initialContextState: NewPreviewResource = {
  payload: {
    name: nothing(),
    description: nothing(),
    search: 'exploration_disable',
    browse_all: false,
    internal_name: nothing(),
    default_product_collection: {
      name: nothing(),
      description: nothing(),
      experiences: [],
      display_type: 'grid',
      learning_design_state: 'browse-all',
    },
    recommended_product_collection: {
      name: nothing(),
      description: nothing(),
      experiences: [],
      display_type: 'grid',
      learning_design_state: 'blank',
    },
  },
  links: [],
};

export const modalDescription = (publishMode: PublishMode): TPlainTextKey => {
  switch (publishMode) {
    case 'Publish':
      return 'Publishing the collection will end the session with EXO and you will not be able to resume the same chat again later - future edits to the collection must be done manually. Are you sure you want to continue?';
    case 'Create':
      return 'Creating the collection will end the session with EXO and you will not be able to resume the same chat again later - future edits to the collection must be done manually. Are you sure you want to continue?';
    case 'Save':
      return 'Saving the collection will end the session with EXO and you will not be able to resume the same chat again later - future edits to the collection must be done manually. Are you sure you want to continue?';
  }
};

export const collectionTitleTimeStamp = (): TPlainTextKey => {
  return 'Name your collection';
};
